import Video from "./Video.vue"
export default Video